import { c as _c } from "react/compiler-runtime";
import { useRequestErrorToast } from '@onefootprint/hooks';
import { IcoRefresh16 } from '@onefootprint/icons';
import { Dropdown, useConfirmationDialog, useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { runWorkflow } from '@/features/onboarding-trace';
import useSession from '@/hooks/use-session';
type RetryNodeProps = {
  id: string;
  workflowId: string;
  onClick: () => void;
};
const RetryNode = t0 => {
  const $ = _c(22);
  const {
    id,
    workflowId,
    onClick
  } = t0;
  const {
    toast
  } = useToast();
  const showErrorToast = useRequestErrorToast();
  const confirm = useConfirmationDialog();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "retryNode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    authHeaders
  } = useSession();
  let t2;
  if ($[1] !== authHeaders || $[2] !== id || $[3] !== workflowId) {
    t2 = () => runWorkflow(authHeaders, {
      id: workflowId,
      clearNodeIds: [id]
    });
    $[1] = authHeaders;
    $[2] = id;
    $[3] = workflowId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t || $[6] !== toast) {
    t3 = () => {
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
    };
    $[5] = t;
    $[6] = toast;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== showErrorToast || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: showErrorToast
    };
    $[8] = showErrorToast;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const mutation = useMutation(t4);
  let t5;
  if ($[12] !== confirm || $[13] !== mutation || $[14] !== onClick || $[15] !== t) {
    t5 = () => {
      onClick();
      confirm.open({
        title: t(_temp3),
        description: t(_temp4),
        primaryButton: {
          label: t(_temp5),
          onClick: () => mutation.mutate(undefined)
        },
        secondaryButton: {
          label: t(_temp6)
        }
      });
    };
    $[12] = confirm;
    $[13] = mutation;
    $[14] = onClick;
    $[15] = t;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const handleRetry = t5;
  let t6;
  if ($[17] !== t) {
    t6 = t(_temp7);
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== handleRetry || $[20] !== t6) {
    t7 = <Dropdown.Item iconLeft={IcoRefresh16} onSelect={handleRetry}>{t6}</Dropdown.Item>;
    $[19] = handleRetry;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default RetryNode;
function _temp($) {
  return $.toast.title;
}
function _temp2($_0) {
  return $_0.toast.description;
}
function _temp3($_1) {
  return $_1.confirm.title;
}
function _temp4($_2) {
  return $_2.confirm.description;
}
function _temp5($_3) {
  return $_3.confirm.cta;
}
function _temp6($_4) {
  return $_4.confirm.cancel;
}
function _temp7($_5) {
  return $_5.label;
}